import { ValueFunction } from '../../index';

function methodSubtract({a = null, b = null}) {
  if (a !== null || b !== null) {
    return a - b;
  } else {
    return null;
  }
}

export const subtract = new ValueFunction(
  methodSubtract,
  {
    label: 'Subtract Two Series',
    description: 'a - b',
    parameters: [
      {'name': 'a', 'type': 'number'},
      {'name': 'b', 'type': 'number'}
    ],
    maxLength: 2
  }
);